(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["colourland-enquiry-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__colourlandEnquiryTracking || window.Shopify?.designMode) return;
    window.__colourlandEnquiryTracking = true;

    const forms = new Map([
      ['ContactForm', 'general_contact_form'],
      ['NeedPainterReferralForm', 'painter_referral_form']
    ]);
    const prefix = 'colourland:enquiry-pending:';
    const maxAge = 30 * 60 * 1000;
    const requested = new Set();

    const allowed = () => {
      try {
        return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
      } catch {
        return false;
      }
    };

    const clear = (id) => {
      try {
        window.sessionStorage.removeItem(prefix + id);
      } catch {}
    };

    const confirmed = new Map();
    for (const [id, source] of forms) {
      const form = document.getElementById(id);
      if (!form) continue;
      if (form.querySelector('[data-colourland-enquiry-success]')) {
        confirmed.set(id, source);
      } else {
        clear(id);
      }
    }

    document.addEventListener('submit', (event) => {
      const id = event.target?.id;
      if (!forms.has(id)) return;
      requested.add(id);
      clear(id);
      if (!allowed()) return;
      try {
        window.sessionStorage.setItem(prefix + id, String(Date.now()));
      } catch {}
    }, true);

    const confirm = () => {
      if (document.readyState !== 'complete') return;
      for (const [id, source] of confirmed) {
        if (!window.Shopify?.customerPrivacy) continue;
        if (!allowed()) {
          clear(id);
          continue;
        }
        if (requested.has(id) || typeof window.gtag !== 'function') continue;
        let pending;
        try {
          pending = window.sessionStorage.getItem(prefix + id);
        } catch {
          continue;
        }
        const age = Date.now() - Number(pending);
        if (!pending || !Number.isFinite(age) || age < 0 || age > maxAge) {
          clear(id);
          continue;
        }
        requested.add(id);
        window.gtag('get', 'G-0HKDRX1NWY', 'client_id', (clientId) => {
          if (!allowed()) {
            clear(id);
            return;
          }
          if (!clientId || Date.now() - Number(pending) > maxAge) return;
          try {
            if (window.sessionStorage.getItem(prefix + id) !== pending) return;
            window.sessionStorage.removeItem(prefix + id);
          } catch {
            return;
          }
          window.gtag('event', 'generate_lead', {
            send_to: 'G-0HKDRX1NWY',
            form_id: id,
            lead_source: source,
            contact_method: 'website_form'
          });
        });
      }
    };

    document.addEventListener('visitorConsentCollected', () => {
      if (!allowed()) {
        for (const id of forms.keys()) clear(id);
      }
      confirm();
    });
    window.addEventListener('load', confirm, { once: true });
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        confirm
      );
    }
    confirm();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["colourland-mobile-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const enhanceGuide = () => {
      const heading = document.querySelector('.main-page__content #room-by-room-paint-selection');
      if (!heading) return;
      const content = heading.closest('.main-page__content');
      const table = Array.from(content.querySelectorAll('table')).find((candidate) =>
        heading.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING
      );
      if (!table || table.hasAttribute('data-cl-mobile-guide')) return;
      const header = table.tHead;
      const body = table.tBodies[0];
      if (!header || header.rows.length !== 1 || !body || table.tBodies.length !== 1) return;
      const columns = Array.from(header.rows[0].cells);
      const rows = Array.from(body.rows);
      if (columns.length !== 3 || !columns.every((cell) => cell.tagName === 'TH' && cell.scope === 'col')) return;
      if (!rows.length || !rows.every((row) => row.cells.length === 3 &&
        Array.from(row.cells).every((cell, index) => cell.colSpan === 1 && cell.rowSpan === 1 &&
          (index === 0 ? cell.tagName === 'TH' && cell.scope === 'row' : cell.tagName === 'TD')))) return;
      table.setAttribute('role', 'table');
      header.setAttribute('role', 'rowgroup');
      header.rows[0].setAttribute('role', 'row');
      columns.forEach((cell) => cell.setAttribute('role', 'columnheader'));
      body.setAttribute('role', 'rowgroup');
      rows.forEach((row) => {
        row.setAttribute('role', 'row');
        Array.from(row.cells).forEach((cell, index) => {
          cell.setAttribute('role', index === 0 ? 'rowheader' : 'cell');
          if (index === 0) return;
          const label = document.createElement('span');
          label.className = 'cl-mobile-guide-label';
          label.setAttribute('aria-hidden', 'true');
          label.textContent = columns[index].textContent.trim();
          cell.prepend(label);
        });
      });
      table.setAttribute('data-cl-mobile-guide', '');
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhanceGuide, { once: true });
    } else {
      enhanceGuide();
    }
    document.addEventListener('shopify:section:load', enhanceGuide);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["colourland-phone-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__colourlandPhoneTracking) return;
    window.__colourlandPhoneTracking = true;

    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        () => {}
      );
    }

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const link = target?.closest('a[href]');
      const href = link?.getAttribute('href')?.trim();
      if (!href || !/^tel:/i.test(href)) return;

      const number = href.slice(4).replace(/[\s()+.-]/g, '');
      if (number !== '9053325033' && number !== '19053325033') return;
      if (typeof window.gtag !== 'function') return;

      try {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      } catch {
        return;
      }

      window.gtag('event', 'phone_click', {
        send_to: 'G-0HKDRX1NWY',
        link_url: 'tel:+19053325033',
        contact_method: 'phone'
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
